import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { createRootRouteWithContext, createRouter, RouterProvider } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen.ts";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import queryClient from './utils/getQueryClient';
import { useUserStore } from "./stores/userStore.ts";


const router = createRouter({
	routeTree,
	context: {
		queryClient,
		userStore: {
			setState: useUserStore.getState().set,
			getState: useUserStore.getState
		}
	},
	defaultPreload: 'intent',
	defaultPreloadStaleTime: 0,
	scrollRestoration: true,
})

declare module '@tanstack/react-router' {
	interface Register {
		router: typeof router
	}
}

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
	<React.StrictMode>
		<QueryClientProvider client={queryClient}>
			<RouterProvider router={router} />
		</QueryClientProvider>
	</React.StrictMode>
);
